<div class="desktop-step-three">
  <div class="desktop-step-three__card">
    <div class="desktop-step-three__side-by-side">
      <div class="desktop-step-three__form">
        <h4 class="desktop-step-three__title">
          {{ 'searchSubscription.yourDetails' | i18n }}
        </h4>

        <div class="desktop-step-three__user-info">
          <lib-search-subscription-form></lib-search-subscription-form>
        </div>
      </div>

      <div class="desktop-step-three__chips">
        <h4 class="desktop-step-three__chips-title">
          {{ 'searchSubscription.yourSearchCriteria' | i18n }}
        </h4>

        <lib-filter-chips [alwaysOpen]="true"></lib-filter-chips>
      </div>
    </div>
    <p
      class="desktop-step-three__legal_notes caption caption--grey"
      [innerHTML]="'searchSubscription.form.thirdPartyHint' | i18n"
    ></p>
  </div>
</div>
